import Components from "slotworks/components/components";
import AllWinsMediator from "slotworks/mediators/all-wins-mediator";
import AutoplayModel from "slotworks/model/autoplay-model";
import GameState from "slotworks/model/game-state";
import FreespinRecord from "slotworks/model/gameplay/records/freespin-record";
import Record from "slotworks/model/gameplay/records/record";
import LineResult from "slotworks/model/gameplay/records/results/line-result";
import State from "slotworks/state-machine/states/state";
import { parallel } from "slotworks/utils/race-utils";
import Timer from "slotworks/utils/timer";
import Regulation from "slotworks/integration/revolver/regulations/regulation";
import WayResult from "integration/builders/way-result";
import betModel from "slotworks/model/bets/bet-model";
import G288SpinRecord from "integration/spin-record";
import { isBigWinInBaseGame } from "utils/utils";
import soundManager from "slotworks/sound/sound-manager";
import G288FreespinRecord from "integration/freespin-record";
import { ShakeLayers } from "commands/shake-command";
import Layers from "slotworks/graphics/layers/layers";
import { UnlockSymbols } from "commands/symbols-commands";

export default class ShowWins extends State {

    public static MULTILINE_ONLY: boolean = false;
    public static WIN_TICK_TIME: number = 750;
    public static END_DELAY: number = 500;

    private onDisplayComplete: Function;
    private timer: number;
    private inComplete:boolean = false;

    public onEnter() {
        const record = GameState.getCurrentGame().getCurrentRecord() as G288SpinRecord;
        const results = record.results;
        this.inComplete = false;

        let wayWins: number = 0;
        for (const result of results) {
            if (result instanceof WayResult) {
                wayWins++;
            }
        }
        
        const totalWin = GameState.getCurrentGame().inFreespinsGame ? GameState.getCurrentGame().getRunningFreespinsWinTotal() : GameState.getCurrentGame().totalCreditsWon;
        const totalBet = betModel.getTotalBet();

        if((record.freespinsTriggered || (record as G288FreespinRecord).retriggerFreespins) && record.results.length == 1) {
            this.complete();
            return;
        }

        UnlockSymbols(Components.matrix.getGridSymbols());

        if(record.results.length == 1 && record.stackAddFeatureTriggered && 
                (GameState.getCurrentGame().inFreespinsGame || !Components.bigWin.isBigWin(record.creditsWon, betModel.getTotalBet()))) {
            Components.betBar.winnings.setWinnings(record.creditsWon, totalWin, 750);
            Regulation.updateNetPosition(GameState.getNetPosition());
            this.complete();
            return;
        }

        if (wayWins === 1 && this.onlyShowOnMultipleWinLines(record)) {
            Components.betBar.winnings.setWinnings(record.creditsWon, totalWin, 0);
            Regulation.updateNetPosition(GameState.getNetPosition());
            this.complete();
            return;
        }

        if(!GameState.getCurrentGame().inFreespinsGame && record.stackAddFeatureTriggered && Components.bigWin.isBigWin(totalWin, totalBet)) {
            Components.betBar.winnings.setWinnings(record.creditsWon, totalWin, 0);
            Regulation.updateNetPosition(GameState.getNetPosition());
            this.complete();
            return;
        }
        
        if(GameState.getCurrentGame().inFreespinsGame) {
            soundManager.customEvent("freespins_music_silent");
        } else {
            soundManager.customEvent("base_music_silent");
        }

        const raceFuncs = [];
        
        if (record.results.length == 1) {
            const result = results[0] as WayResult;
            if (result) {
                raceFuncs.push(() => Components.celebrateWin.singleTotalWin(record.creditsWon, result));
            }
        } else {
            raceFuncs.push(() => Components.celebrateWin.totalWin(record.creditsWon));
        }

        const allWinsMediator = new AllWinsMediator();
        raceFuncs.push(() => allWinsMediator.start());

        let preWin: boolean = false;
        this.onDisplayComplete = (skip: boolean = false) => {
            if(isBigWinInBaseGame() && !record.stackAddFeatureTriggered && !record.freespinsTriggered && !skip) {
                soundManager.customEvent("pre_win");   
                ShakeLayers([Layers.MatrixBackground, Layers.MatrixContent, Layers.MatrixForeground, Layers.SymbolAnimations, Layers.Custom.get("StackAddForeground"),
                        Layers.Footer, Layers.Custom.get("Animations")], 50, 6, 2, 40);
                preWin = true;
            }
            this.onDisplayComplete = null;
            if(!isBigWinInBaseGame()) {
                allWinsMediator.end();
            }
            Components.celebrateWin.hide();
            Components.betBar.winnings.setWinnings(record.creditsWon, totalWin, ShowWins.WIN_TICK_TIME);
            Regulation.updateNetPosition(GameState.getNetPosition());
        };
        
        parallel(raceFuncs).then(() => {
            if (this.onDisplayComplete) {
                this.onDisplayComplete();
                this.inComplete = true;
                this.timer = Timer.setTimeout(() => {
                    this.complete();
                }, ShowWins.END_DELAY + (preWin? 1200 : 0));
            }
        });
    }    

    public onSkip() {
        if(this.inComplete) return;
        if (this.onDisplayComplete) {
            this.onDisplayComplete(true);
        }
        Timer.clearTimeout(this.timer);
        this.skip();
    }

    private isAutospinsOrFreespins(record: Record) {
        return (record instanceof FreespinRecord) || AutoplayModel.isAutoPlaying();
    }

    private onlyShowOnMultipleWinLines(record: Record) {
        return !this.isAutospinsOrFreespins(record) && ShowWins.MULTILINE_ONLY;
    }
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./src/states/show-wins.ts